// import { dateToTime } from "./utitity";
// import { CryptoJSAesDecrypt } from "./cryp";
// import { userProfile } from "../services/auth.service";

// //Return access token

// /**
//  * @deprecated
//  */
// export const getAccessToken = () => {
//   return AppCache.getApplicationJwt();
// };

// /**
//  * Save access token in local storage
//  * @deprecated 
//  * @param {String} token
//  */
// export const setToken = (token) => {
//   AppCache.setApplicationJwt(token);
// };

// //Return access token

// /**
//  * @deprecated
//  */
// export const getCode = () => {
//   if (localStorage.getItem("code")) {
//     return localStorage.getItem("code");
//   }

//   return null;
// };

// //Check and return service token

// /**
//  * @deprecated
//  */
// export const getServiceToken = () => {
//   if (localStorage.getItem("s_token")) {
//     return localStorage.getItem("s_token");
//   }
//   return null;
// };

// /**
//  * @deprecated
//  */
// export const setNodeList = (nodeList) => {
//   localStorage.setItem("nodeList", JSON.stringify(nodeList));
// };

// /**
//  * @deprecated
//  */
// export const getNodeList = () => {
//   if (localStorage.getItem("nodeList")) {
//     return JSON.parse(localStorage.getItem("nodeList"));
//   }
//   return null;
// };

// /**
//  * @deprecated
//  */
// export const setNode = (node) => {
//   localStorage.setItem("node", node);
// };
// /**
//  * @deprecated
//  */
// export const getNode = () => {
//   if (localStorage.getItem("node")) {
//     return localStorage.getItem("node");
//   }
//   return null;
// };

// /**
//  * @deprecated
//  */
// export const setCode = (code) => {
//   localStorage.setItem("code", code);
// };


// /**
//  * Save service token in local storage
//  * @deprecated use setServiceToken2 instead
//  * @param {String} token
//  */
// export const setServiceToken = (token) => {
//   localStorage.removeItem("s_token");
//   localStorage.setItem("s_token", token);
// };

// export const setServiceToken2 = (code, data) => {
//   localStorage.setItem("s_token_" + code, JSON.stringify(data));
// };

// export const getServiceToken2 = (code) => {
//   return AppCache.getServiceJWT(code);
// };

// /**
//  * Remove both token from User Pc
//  */
// export const removeToken = () => {
//   localStorage.removeItem("s_token");
//   localStorage.removeItem("a_token");
//   localStorage.removeItem("code");
//   localStorage.removeItem("nodeList");
//   localStorage.removeItem("node");
//   localStorage.removeItem("mail_token");
//   localStorage.removeItem("mail_link");
//   localStorage.removeItem("tv_token");
//   localStorage.removeItem("tv_link");
// };



// //Get only user info from access token
// export const getUser = (tokenInfo = null) => {
//   if (tokenInfo) {
//     return tokenInfo.user;
//   }

//   const token = getAccessToken();
//   if (token) {
//     try {
//       const decrypted = CryptoJSAesDecrypt(token);
//       const parsed = JSON.parse(decrypted);
//       return { ...parsed.user, conncetionCode: getCode() };
//     } catch (err) {
//       console.error("getUser Hatası:", err.message);
//     }
//   }
//   return {};
// };

// export const getTest = () => {
//   let data = `${getAccessToken()}.${getServiceToken()}`
//   console.log(data);
// };

// export const setTokenForMail = (token) => {
//   localStorage.removeItem("mail_token");
//   localStorage.setItem("mail_token", token);
// };

// export const getTokenForMail = () => {
//   if (localStorage.getItem("mail_token")) {
//     return localStorage.getItem("mail_token");
//   }
//   return null;
// };
// export const setLinkForMail = (link) => {
//   localStorage.removeItem("mail_link");
//   localStorage.setItem("mail_link", link);
// };
// export const getLinkForMail = () => {
//   if (localStorage.getItem("mail_link")) {
//     return localStorage.getItem("mail_link");
//   }
//   return null;
// };

// export const getTokenForTvDashboard = () => {
//   if (localStorage.getItem("tv_token")) {
//     return localStorage.getItem("tv_token");
//   }
//   return null;
// };
// export const setTokenForTvDashboard = (token) => {
//   localStorage.removeItem("tv_token");
//   localStorage.setItem("tv_token", token);
// };

// export const getTokenForPartner = () => {
//   return localStorage.getItem("partner_token") ?? null;
// };
// export const setTokenForPartner = (token) => {
//   localStorage.setItem("partner_token", token);
// };

// export const setLinkForPartner = (link) => {
//   localStorage.setItem("partner_link", link);
// };
// export const getLinkForPartner = () => {
//   return localStorage.getItem("partner_link") ?? null;
// };
// export const getLinkForTvDashboard = () => {
//   return localStorage.getItem("tv_link") ?? null;
// };

// export const setLinkForTvDashboard = (link) => {
//   localStorage.removeItem("tv_link");
//   localStorage.setItem("tv_link", link);
// };

// /**
//  * Get expire timestamp of access token and compare from the current time plus 10 minutes
//  * If expire token have 10 minutes or less to expire then return true other wise false
//  * On the basis of true or false application decide to make renew token call to rest api server
//  *
//  * @param {int} exp
//  * @returns {bool}
//  */
// export const shouldTokenRenew = (exp) => {
//   //Check expiry is less than 10 minutes from curren time
//   const refreshThreshold = new Date().getTime();
//   const diff = exp - refreshThreshold;
//   if (diff > 0 && diff < 500000) {
//     return true;
//   }
//   return false;
// };

// /**
//  * 
//  * @deprecated
//  */
// export const isSessionExpired = () => {
//   return AppCache.isLoggedIn() === false;
// };


// export class AppCache {

//   static onLoggout() {
//     sessionStorage.clear();
//   }


//   static isLoggedIn() {
//     return sessionStorage.getItem("user-profile") ? true : false;
//   }

//   /**
//   * 
//   * @param {String} jwt 
//   */
//   static setUserProfile(userProfile) {
//     sessionStorage.setItem("user-profile", JSON.stringify(userProfile));
//   }

/**
 * 
 * @returns {String}
 */
// static getUserProfile() {
//   if (sessionStorage.getItem("user-profile")) {
//     return JSON.parse(sessionStorage.getItem("user-profile"));
//   }
//   return null;
// }


//   /**
//    * 
//    * @param {String} jwt 
//    */
//   static setApplicationJwt(jwt) {
//     sessionStorage.setItem("a_jwt", jwt);
//   }

//   /**
//    * 
//    * @returns {String}
//    */
//   static getApplicationJwt() {
//     return sessionStorage.getItem("a_jwt") ?? null;
//   }


//   // Getter for language
//   static getCurrentLanguage() {
//     return localStorage.getItem("lang") ?? "en";
//   }

//   // Setter for language
//   static setCurrentLanguage(lang) {
//     localStorage.setItem("lang", lang);
//   }

//   static setServicelist(serviceList) {
//     if (serviceList == null) {
//       return sessionStorage.removeItem("service-list");
//     }
//     return sessionStorage.setItem("service-list", JSON.stringify(serviceList));
//   }

//   // static getServicelist() {
//   //   return JSON.parse(sessionStorage.getItem("service-list")) ?? null;
//   // }

//   // static getService(code) {
//   //   const servicelist = AppCache.getServicelist();
//   //   if (!Array.isArray(servicelist)) return null;
//   //   return servicelist.find((s) => s.code === code);
//   // }

//   // static getServiceJWT(code) {
//   //   return AppCache.getService(code).jwt;
//   // }
//   // static getServiceJWT(code) {
//   //   const service = AppCache.getService(code);
//   //   return service?.jwt ?? null;  // optional chaining + fallback
//   // }

//   static setSelectedConnection(connection) {
//     if (connection == null) {
//       return sessionStorage.removeItem("selected-connection");
//     }
//     return sessionStorage.setItem("selected-connection", JSON.stringify(connection));
//   }

//   static getSelectedConnection() {
//     return JSON.parse(sessionStorage.getItem("selected-connection")) ?? null;
//   }

//   static setSelectedConnectionNode(node) {
//     if (node == null) {
//       return sessionStorage.removeItem("selected-connection-node");
//     }
//     return sessionStorage.setItem("selected-connection-node", JSON.stringify(node));
//   }

//   static getSelectedConnectionNode() {
//     return JSON.parse(sessionStorage.getItem("selected-connection-node")) ?? null;
//   }

//   static setConnections(connections) {
//     if (connections == null) {
//       return sessionStorage.removeItem("connections");
//     }
//     return sessionStorage.setItem("connections", JSON.stringify(connections));
//   }

//   static getConnections() {
//     return JSON.parse(sessionStorage.getItem("connections") ?? []);
//   }

// }


import { dateToTime } from "./utitity";
import { CryptoJSAesDecrypt } from "./cryp";

//Return access token
export const getAccessToken = () => {
  if (localStorage.getItem("a_token")) {
    return localStorage.getItem("a_token");
  }

  return null;
};

//Return access token
export const getCode = () => {
  if (localStorage.getItem("code")) {
    return localStorage.getItem("code");
  }

  return null;
};

//Check and return service token
export const getServiceToken = () => {
  if (localStorage.getItem("s_token")) {
    return localStorage.getItem("s_token");
  }
  return null;
};
export const setNodeList = (nodeList) => {
  localStorage.setItem("nodeList", JSON.stringify(nodeList));
};
export const getNodeList = () => {
  if (localStorage.getItem("nodeList")) {
    return JSON.parse(localStorage.getItem("nodeList"));
  }
  return null;
};
export const setNode = (node) => {
  localStorage.setItem("node", node);
};
export const getNode = () => {
  if (localStorage.getItem("node")) {
    return localStorage.getItem("node");
  }
  return null;
};

export const setCode = (code) => {
  localStorage.setItem("code", code);
};

/**
 * Save access token in local storage
 *
 * @param {String} token
 */
export const setToken = (token) => {
  localStorage.removeItem("a_token");
  localStorage.setItem("a_token", token);
};

/**
 * Save service token in local storage
 *
 * @param {String} token
 */
export const setServiceToken = (token) => {
  localStorage.removeItem("s_token");
  localStorage.setItem("s_token", token);
};

export const setServiceToken2 = (code, data) => {
  localStorage.setItem("s_token_" + code, JSON.stringify(data));
};

export const getServiceToken2 = (code) => {
  const stringData = localStorage.getItem("s_token_" + code);
  if (stringData == null) return false;
  return JSON.parse(stringData);
};

/**
 * Remove both token from User Pc
 */
export const removeToken = () => {
  localStorage.removeItem("s_token");
  localStorage.removeItem("a_token");
  localStorage.removeItem("code");
  localStorage.removeItem("nodeList");
  localStorage.removeItem("node");
  localStorage.removeItem("mail_token");
  localStorage.removeItem("mail_link");
  localStorage.removeItem("tv_token");
  localStorage.removeItem("tv_link");
};

//Decode access token and get user info from it and decoded value
export const getTokenInfo = () => {
  //later we will get info from saved app jwt
  let data = {
    token: null,
    user: {},
    exp: 0,
    authAppId: null,
  };
  let token = getAccessToken();
  if (token) {
    data = JSON.parse(CryptoJSAesDecrypt(token));
    data.user.conncetionCode = getCode();
    data.token = token;
    data.exp = dateToTime(data.exp);
  }

  return data;
};

//Get only user info from access token
export const getUser = (tokenInfo = null) => {
  //later we will get info from saved app jwt
  if (tokenInfo) {
    return tokenInfo.user;
  }

  let token = getAccessToken();
  if (token) {
    let { user } = JSON.parse(CryptoJSAesDecrypt(token));
    return { ...user, conncetionCode: getCode() };
  }

  return {};
};

export const getTest = () => {
  let data = `${getAccessToken()}.${getServiceToken()}`
};

export const setTokenForMail = (token) => {
  localStorage.removeItem("mail_token");
  localStorage.setItem("mail_token", token);
};

export const getTokenForMail = () => {

  if (localStorage.getItem("mail_token")) {
    return localStorage.getItem("mail_token");
  }
  return null;
};
export const setLinkForMail = (link) => {

  localStorage.removeItem("mail_link");
  localStorage.setItem("mail_link", link);
};
export const getLinkForMail = () => {
  if (localStorage.getItem("mail_link")) {
    return localStorage.getItem("mail_link");
  }
  return null;
};

export const getTokenForTvDashboard = () => {
  if (localStorage.getItem("tv_token")) {
    return localStorage.getItem("tv_token");
  }
  return null;
};
export const setTokenForTvDashboard = (token) => {
  localStorage.removeItem("tv_token");
  localStorage.setItem("tv_token", token);
};

export const getTokenForPartner = () => {
  return localStorage.getItem("partner_token") ?? null;
};
export const setTokenForPartner = (token) => {
  localStorage.setItem("partner_token", token);
};

export const setLinkForPartner = (link) => {
  localStorage.setItem("partner_link", link);
};
export const getLinkForPartner = () => {
  return localStorage.getItem("partner_link") ?? null;
};
export const getLinkForTvDashboard = () => {
  return localStorage.getItem("tv_link") ?? null;
};

export const setLinkForTvDashboard = (link) => {
  localStorage.removeItem("tv_link");
  localStorage.setItem("tv_link", link);
};

/**
 * Get expire timestamp of access token and compare from the current time plus 10 minutes
 * If expire token have 10 minutes or less to expire then return true other wise false
 * On the basis of true or false application decide to make renew token call to rest api server
 *
 * @param {int} exp
 * @returns {bool}
 */
export const shouldTokenRenew = (exp) => {
  //Check expiry is less than 10 minutes from curren time
  const refreshThreshold = new Date().getTime();
  const diff = exp - refreshThreshold;
  if (diff > 0 && diff < 500000) {
    return true;
  }
  return false;
};

export const isSessionExpired = () => {
  let { exp } = getTokenInfo();
  const currentTime = new Date().getTime();
  if (exp > 0) {
    const diff = exp - currentTime;
    return diff <= 0;
  }
  return true;
};


export class AppCache {

  // Getter for language
  static getCurrentLanguage() {
    return localStorage.getItem("lang") ?? "en";
  }

  // Setter for language
  static setCurrentLanguage(lang) {
    localStorage.setItem("lang", lang);
  }

  static getApplicationJwt() {
    return localStorage.getItem("a_token") ?? null;
  }

  static getServiceJWT(code) {
    if (localStorage.getItem("s_token_" + code)) {
      const service = JSON.parse(localStorage.getItem("s_token_" + code));
      return service?.jwt ?? null;
    } else {
      return null;
    }

  }
  static getSelectedConnection() {
    return localStorage.getItem("code") ?? null;
  }

    static setSelectedConnection(code) {
     localStorage.setItem("code", code);
  }
}